<template src="./customers.html"></template>

<script>
import mixins from "@/mixins/mixins.js";
import ExportReport from "@/components/export-report/ExportReport.vue";
import SearchByDate from "@/components/search-by-date/SearchByDate.vue";
import moment from "moment";
export default {
  mixins: [mixins],
  components: { ExportReport, SearchByDate},
  data() {
    return {
      historic: [],
      selected: [],
      search: "",
      searchUrl:"",
      csvHistoric: {},
      historicCsv: [],
      date: {
        initial: null,
        final: null,
      },
      busy: true,
    };
  },
  mounted: function () {
    let vm = this;
    vm.init();
  },
  methods: {
    init() {
      let vm = this;
      vm.date.final = moment().format('YYYY-MM-DD');
      vm.date.initial = moment().clone().startOf("M").format('YYYY-MM-DD');
      if (vm.$session.get("userAasId") !== undefined) {
        vm.getRecommendations();
      }
    },
    getSearchUrl() {
      const vm = this;
      const search = vm.testNullUndefinedEmpty(vm.search)? "": "&search=" + vm.search;
      const date = vm.testNullUndefinedEmpty(vm.date) ||vm.testNullUndefinedEmpty(vm.date.initial) || vm.testNullUndefinedEmpty(vm.date.final) ? "" :
        "&initialDate=" + vm.date.initial + "&finalDate=" + vm.date.final;
      vm.searchUrl = search + date;
    },
    updateSearchDate(date) {
      const vm = this;
      vm.currentx = 1;
      vm.date = date;
      vm.$vs.loading();
      
      vm.getRecommendations();
      vm.$vs.loading.close();
    },
    handleSelected() {},

    getRecommendations() {
      let vm = this;
      const initialDate = vm.date.initial;
      const  finalDate = vm.date.final;
      vm.getSearchUrl();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "aas/indicates/metrics?initialDate=" + initialDate + "&finalDate=" + finalDate ,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          console.log(response);
          if (response.status === 200) {
            vm.historic = response.data;
            vm.busy = false;
            for (let h in vm.historic) {
              vm.historic[h].zipcode = vm.testNullUndefinedEmpty(
                vm.historic[h].zipcode
              )
                ? "Sem registro"
                : vm.maskZipcode(vm.historic[h].zipcode);
              vm.historic[h].createDate  = vm.testNullUndefinedEmpty(
                vm.historic[h].createDate 
              )
                ? "Sem registro"
                : vm.historic[h].createDate;
            }
            vm.$vs.loading.close();
            vm.fillCSV();
          }
        })
        .catch(function () {
          vm.busy = false;
        });
    },
    // exportCustomers() {
    //   let vm = this;
    //   for(let c in vm.historic) {
    //     vm.historicCsv.push(Object.assign({}, vm.csvHistoric));
    //   }
    // },
  },
};
</script>
<style lang="scss" src="./customers.scss">
</style>